import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MembershipLevel, MembershipLevelStatus } from '../models/membership-level.model';

export const MembershipActions = createActionGroup({
  source: 'Membership',
  events: {
    'Clear Levels': emptyProps(),

    'Load Levels': props<{ propertyId: string }>(),
    'Load Levels Success': props<{ propertyId: string; levels: MembershipLevel[] }>(),
    'Load Levels Failure': props<{ error: unknown }>(),

    'Create Level': props<{
      propertyId: string;
      draft: Omit<MembershipLevel, 'membershipCategoryId'>;
    }>(),
    'Create Level Success': props<{ propertyId: string; level: MembershipLevel }>(),
    'Create Level Failure': props<{ error: unknown }>(),

    'Update Level': props<{ propertyId: string; level: MembershipLevel }>(),
    'Update Level Success': props<{ propertyId: string; level: MembershipLevel }>(),
    'Update Level Failure': props<{ error: unknown }>(),

    'Delete Level': props<{ propertyId: string; membershipCategoryId: string }>(),
    'Delete Level Success': props<{ propertyId: string; membershipCategoryId: string }>(),
    'Delete Level Blocked': emptyProps(),
    'Delete Level Failure': props<{ error: unknown }>(),

    'Bulk Update Status': props<{
      propertyId: string;
      membershipCategoryIds: string[];
      status: MembershipLevelStatus;
    }>(),
    'Bulk Update Status Failure': props<{ error: unknown }>(),

    'Bulk Delete Levels': props<{ propertyId: string; membershipCategoryIds: string[] }>(),
    'Bulk Delete Levels Failure': props<{ error: unknown }>(),
  },
});
